export enum ApprovalStatus {
    PENDING = "pending",
    REVIEWED = "reviewed",
    APPROVED = "approved",
    CHANGES_REQUESTED = "changes_requested"
}

export const ApprovalStatusLabel = {
    [ApprovalStatus.PENDING]: "Pending review",
    [ApprovalStatus.REVIEWED]: "Reviewed",
    [ApprovalStatus.APPROVED]: "Approved",
    [ApprovalStatus.CHANGES_REQUESTED]: "Changes requested"
};

export const ApprovalStatusIndicatorColor = {
    [ApprovalStatus.PENDING]: "var(--marker-yellow)",
    [ApprovalStatus.REVIEWED]: "var(--marker-turquoise)",
    [ApprovalStatus.APPROVED]: "var(--marker-jade)",
    [ApprovalStatus.CHANGES_REQUESTED]: "var(--marker-orange)"
};
